import { gql } from "@apollo/client";

export const GET_REPORT_OPERATORS = gql`
    query GetReportOperators {
        getReportOperators {
            id
            name
        }
    }
`;

export interface ReportOperatorType {
    id: string;
    name: string;
}

export interface GetReportOperatorsResponse {
    getReportOperators: ReportOperatorType[];
}